import { Wrench, Zap } from "lucide-react";

// Shared left brand panel used by Login-style public auth pages.
export function AuthBrandPanel() {
  return (
    <div className="hidden lg:block relative overflow-hidden border-r border-border">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1636761358783-209512dccd98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/85 via-black/70 to-black/90" />
      <div className="relative z-10 h-full p-12 flex flex-col justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-primary flex items-center justify-center">
            <Wrench className="w-5 h-5 text-primary-foreground" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display font-black text-2xl uppercase tracking-tight leading-none">SynqMoto<span className="text-primary"> ERP</span></div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Two-Wheeler Ops Center</div>
          </div>
        </div>
        <div>
          <div className="text-primary text-xs uppercase tracking-[0.3em] mb-3 flex items-center gap-2">
            <Zap className="w-3 h-3" /> Command Center
          </div>
          <h1 className="font-display font-black text-6xl uppercase tracking-tighter leading-[0.9] mb-4">
            Every bolt.<br />Every rupee.<br /><span className="text-primary">Tracked.</span>
          </h1>
          <p className="text-muted-foreground max-w-md text-sm leading-relaxed">
            Job cards, parts inventory, GST billing, and mechanic productivity — one operational hub for your workshop.
          </p>
        </div>
        <div className="text-[10px] text-muted-foreground uppercase tracking-[0.2em]">
          v1.0 · Built for Indian Two-Wheeler Workshops
        </div>
      </div>
    </div>
  );
}
